import React from 'react'
import Loader from '../../../images/icon/loaderBlack.svg'
import classes from '../MobileExchanger.module.css'

export default function loader() {
    return (
        <>
            <div className={classes.loader}>
                <img src={Loader} height={70} alt={'preloader'} />
            </div>
        </>
    )
}